export const LinkValues = {
  site: "https://rebix.io",
  schema: {
    transactions: (address) => `rebix://transaction?address=${address}`,
  },
  routes: {
    base: (urlSyntax = true, onlyIR = false) =>
      `${(onlyIR && "https://rebix.ir") || ""}/${
        (urlSyntax && ":locale(en|fa)?/") || ""
      }`,
    market: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}market`,
    },
    earn: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}earn`,
    },
    wallet: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}wallet`,
    },
    about: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}about`,
    },
    trade: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}trade`,
    },
    wallet: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}wallet/`,
      deposit: {
        self: (urlSyntax = true) =>
          `${LinkValues.routes.wallet.self(urlSyntax)}deposit/`,
        external: (urlSyntax = true) =>
          `${LinkValues.routes.wallet.deposit.self(
            urlSyntax
          )}external/:wallet/:amount/:senderEmail/:code`,
      },
    },
    auth: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}auth/`,
      login: (urlSyntax = true) =>
        `${LinkValues.routes.auth.self(urlSyntax)}login`,
      register: (urlSyntax = true) =>
        `${LinkValues.routes.auth.self(urlSyntax)}register`,
    },
    terms: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}terms`,
    },
    privacy: {
      self: (urlSyntax = true) => `${LinkValues.routes.base(urlSyntax)}privacy`,
    },
    liveSupport: {
      self: (urlSyntax = true) =>
        `${LinkValues.routes.base(urlSyntax)}live-support`,
    },
    coreview: {
      self: (urlSyntax = true) =>
        `${LinkValues.routes.base(urlSyntax)}coreview/`,
      transaction: {
        self: (urlSyntax = true) =>
          `${LinkValues.routes.coreview.self(urlSyntax)}transaction/`,
        receipt: (urlSyntax = true) =>
          `${LinkValues.routes.coreview.transaction.self(
            urlSyntax
          )}receipt/:txaddress`,
      },
      ipg: {
        self: (urlSyntax = true) =>
          `${LinkValues.routes.coreview.self(urlSyntax)}ipg/`,
        payping: (urlSyntax = true) =>
          `${LinkValues.routes.coreview.ipg.self(urlSyntax)}payping/:txaddress`,
        novinopay: (urlSyntax = true) =>
          `${LinkValues.routes.coreview.ipg.self(
            urlSyntax
          )}novinopay/:txaddress`,
        zarinpal: (urlSyntax = true) =>
          `${LinkValues.routes.coreview.ipg.self(
            urlSyntax
          )}zarinpal/:txaddress`,
      },
    },
    licences: {
      self: (urlSyntax = true, onlyIR = false) =>
        `${LinkValues.routes.base(urlSyntax, onlyIR)}licences/`,
    },
    initLocale: (route, languages) => {
      if (route.startsWith("http") || route.startsWith("https")) return route;
      var pathname = route;
      const splited = window.location.pathname.replace(/\/+$/, "").split("/");
      if (
        splited.length > 1 &&
        languages.find(
          (item) => item.toLowerCase() === splited[1].toLowerCase()
        )
      ) {
        pathname = `/${splited[1].toLowerCase()}${pathname}`;
      } else {
        pathname = `/${languages[0].toLowerCase()}${pathname}`;
      }
      return pathname;
    },
    setLocale: (lang, langList = []) => {
      var pathname = window.location.pathname;
      const splited = window.location.pathname.replace(/\/+$/, "").split("/");
      if (
        splited.length > 1 &&
        langList.find((item) => item.toLowerCase() === splited[1].toLowerCase())
      ) {
        splited[1] = lang;
        pathname = splited.join("/");
      } else {
        pathname = `/${lang}${pathname}`;
      }

      window.location.replace(pathname);
    },
    isRouteUseLocale: (languages) => {
      const splited = window.location.pathname.replace(/\/+$/, "").split("/");
      return (
        splited.length > 1 &&
        languages.find((item) => item.toLowerCase() == splited[1].toLowerCase())
      );
    },
  },
  core: {
    self: "https://api.rebix.io/",
    appviews: {
      self: () => `${LinkValues.core.self}appviews/`,
      banners: () => `${LinkValues.core.appviews.self()}banners/`,
      dialogs: () => `${LinkValues.core.appviews.self()}dialogs/`,
    },
    blockchain: {
      self: () => `${LinkValues.core.self}block/`,
      token: {
        self: () => `${LinkValues.core.blockchain.self()}token/`,
        list: () => `${LinkValues.core.blockchain.token.self()}list/`,
      },
    },
    finance: {
      self: () => `${LinkValues.core.self}finance/`,
      transaction: {
        self: () => `${LinkValues.core.finance.self()}transaction/`,
        details: () => `${LinkValues.core.finance.transaction.self()}details/`,
        externaldepositwallet: () =>
          `${LinkValues.core.finance.transaction.self()}externaldepositwallet/`,
      },
    },
    provider: {
      self: () => `${LinkValues.core.self}provider/`,
      notifications: {
        self: () => `${LinkValues.core.provider.self()}notifications/`,
        list: () => `${LinkValues.core.provider.notifications.self()}list/`,
      },
    },
  },
  styles: {
    images: {
      template: () => `${LinkValues.site}/_ragc/styles/images/template/`,
      applicationView: {
        samsung: (name) =>
          `${LinkValues.styles.images.template()}application_view_samsung_${name}.png`,
      },
    },
  },
  files: {
    template: () => `${LinkValues.site}/_ragc/files/`,
    download: {
      androidApk: () => `${LinkValues.files.template()}android/rebix.apk`,
    },
  },
  images: {
    self: () => `${LinkValues.site}/_ragc/images/`,
    icons: {
      self: () => `${LinkValues.images.self()}icons/`,
      navHeader: (name) =>
        `${LinkValues.images.icons.self()}logo_nav_${name}.png`,
      navHeaderLight: () =>
        `${LinkValues.images.icons.self()}logo_nav_light.png`,
      navHeaderDark: () => `${LinkValues.images.icons.self()}logo_nav_dark.png`,
      stores: {
        cafeBazzar: () =>
          `${LinkValues.images.icons.self()}store_cafebazzar.svg`,
        myket: () => `${LinkValues.images.icons.self()}store_myket.svg`,
      },
    },
    partners: {
      self: () => `${LinkValues.images.self()}partners/`,
      cafeBazzar: () => `${LinkValues.images.partners.self()}cafebazzar.png`,
      myket: () => `${LinkValues.images.partners.self()}myket.png`,
      blockChair: () => `${LinkValues.images.partners.self()}blockchair.png`,
      blockChainCom: () =>
        `${LinkValues.images.partners.self()}blockchaincom.png`,
      etherumNetwork: () =>
        `${LinkValues.images.partners.self()}etherumnetwork.png`,
      parsPack: () => `${LinkValues.images.partners.self()}parspack.png`,
      infura: () => `${LinkValues.images.partners.self()}infura.png`,
      googlePlay: () => `${LinkValues.images.partners.self()}googleplay.png`,
    },
    licences: {
      self: () => `${LinkValues.images.self()}licences/`,
      enamad: () => `${LinkValues.images.licences.self()}enamad.png`,
      samandehi: () => `${LinkValues.images.licences.self()}samandehi.png`,
    },

    company: {
      self: () => `${LinkValues.images.self()}company/`,
      signature: {
        self: () => `${LinkValues.images.company.self()}signatures/`,
        fa: () => `${LinkValues.images.company.signature.self()}Fa.png`,
        en: () => `${LinkValues.images.company.signature.self()}En.png`,
      },
    },
  },
  externals: {
    stores: {
      googlePlay:
        "https://play.google.com/store/apps/details?id=io.rebix.app.android",
      cafeBazzar: "https://cafebazaar.ir/app/io.rebix.app.android",
      myket: "https://myket.ir/app/io.rebix.app.android",
    },
    apis: {
      geoLocationDB: {
        self: "https://geolocation-db.com/",
        json: () => `${LinkValues.externals.apis.geoLocationDB.self}/json/`,
      },
    },
  },
};

export const RequestParamValues = {
  topic: "topic",
};

export const ResponseValues = {
  referredLink: "referred_link",
  title: "title",
  imageUrl: "image_url",
  targetLink: "target_link",
  currencyPairName: "currency_pair_name",
  currencyPairSymbol: "currency_pair_symbol",
  currencyName: "currency_name",
  currencySymbol: "currency_symbol",
  priority: "priority",
  creationDate: "creation_date",
  changes1h: "changes_1h",
  attributes: "attributes",
  price: "price",
  volume24h: "volume_24h",
  sender: "sender",
  receiptLink: "receipt_link",
  receiver: "receiver",
  amount: "amount",
  token: "token",
  ipg: "ipg",
  network: "network",
  type: "type",
  txid: "txid",
  state: "state",
  fee: "fee",
  clientName: "client_name",
  clientMobile: "client_mobile",
  clientEmail: "client_email",
  clientID: "client_id",
  identityState: "identity_state",
  clientSignature: "signature",
  refund: "refund",
  term: "term",
  apy: "apy",
  caption: "caption",
  identityVerification: "identity_verification",
  fullName: "fullname",
  makeConverted: (param) => {
    return `${ResponseValues[param]}__converted`;
  },
};

export const TokenValues = {
  coreAccess:
    "AmbPfgJIWYIAka1wRCCXgCvGGsJgMl8t2vnvjubvipjMDtn5j18D46y0Q5ZnSI1D9doQfIOHUi9cKOFUvV1fnJpXWxzd2UWpDkngc5ptbloAUDJKJcyQUDHy",
};

export const RebixAttributesValues = {
  tokenStableCoin: "TYPE_ATTR_TOKENS_STABLECOIN",
  tokenDefi: "TYPE_ATTR_TOKENS_DEFI",
  tokenMetaverse: "TYPE_ATTR_TOKENS_METAVERSE",
  tokenSmartContract: "TYPE_ATTR_TOKENS_SMARTCONTRACT",
  tokenFiat: "TYPE_ATTR_TOKENS_FIAT",
};

export const RebixDAMValues = {
  termsOfUse: "REBIXTERMS__INFO",
  privacyPolicies: "REBIXTERMS__PRIVACY",
};

export const NotificationTopicValues = {
  system: "TYPE_NOTIFICATIONMESSAGES_TOPIC_SYSTEM",
  announcement: "TYPE_NOTIFICATIONMESSAGES_TOPIC_ANNOUNCEMENT",
};

export const LocalValues = {
  IR: "fa",
  self: "en",
};
